export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14042.a6ca84d0.jpg";